exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-input-number[data-v-f1adbd9a]  .el-input__inner{text-align:left}", ""]);

// exports
